//###[ IMPORTS ]########################################################################################################

import {jQuery as $, lodash as _} from 'lib/shim';

import {Context} from 'context';
import {BREAKPOINT_DESKTOP, BREAKPOINT_TABLET} from 'defines';



//###[ ORGANISMS INIT ]#################################################################################################

import {init as initOrganismHeader} from '30-organisms/globals/10-header';
import {init as initOrganismFooter} from '30-organisms/globals/20-footer';
import {init as initContactPanel} from '30-organisms/globals/40-contact-panel';
import {init as initOrganismStickyPageUp} from '30-organisms/globals/50-sticky-page-up';
import {init as initOrganismPrivacyLayer} from '30-organisms/globals/60-privacy-layer';
import {init as initOrganismMessageOverlay} from '30-organisms/globals/70-message-overlay';


import {init as initAtomSelect} from '10-atoms/formelements/select';
import {init as initAtomCheckbox} from '10-atoms/formelements/checkbox';
import {init as initAtomRadiobutton} from '10-atoms/formelements/radiobutton';
import {init as initAtomTextinput} from '10-atoms/formelements/textinput';
import {init as initAtomTextarea} from '10-atoms/formelements/textarea';


import {init as initInPageNavigation} from '20-molecules/navigation/10-in-page-navigation';
import {init as initMolecule3dViewer} from '20-molecules/media/3d-viewer';
import {init as initMoleculeVideo} from '20-molecules/media/video';
import {init as initMoleculeGoogleMap} from '20-molecules/map/google-map';
import {init as initMoleculeHeaderImage} from '20-molecules/content/20-header-image';


import {init as initOrganismHeaderImageHomepage} from '30-organisms/header-images/21-header-image-homepage';

import {init as initOrganismTeaser3Columns} from '30-organisms/teaser-content-elements/40-teaser-3-columns';
import {init as initTabContentsliderImageTextLink} from '30-organisms/teaser-content-elements/60-tab-contentslider-image-text-link';
import {init as initProductTeaserList} from '30-organisms/teaser-content-elements/80-product-teaser-list';
import {init as initTeaserSlider4Columns} from '30-organisms/teaser-content-elements/90-teaserslider-4columns';
import {init as initImageFullwidthTextbox} from '30-organisms/teaser-content-elements/100-image-fullwidth-textbox';
import {init as initKeyFigures} from '30-organisms/teaser-content-elements/110-key-figures';
import {init as initVerticalTabsTextImage} from '30-organisms/teaser-content-elements/120-vertical-tabs-text-image';
import {init as initCollapsible} from '30-organisms/teaser-content-elements/130-collapsible';
import {init as initOrganismBreakoutImageTabTeaser} from '30-organisms/teaser-content-elements/breakout-image-tab-teaser';
import {init as initOrganismProductIntro} from '30-organisms/teaser-content-elements/product-intro';

import {init as initOrganismFilterbox3Columns} from '30-organisms/filtering/filterbox-3-columns';
import {init as initOrganismFilteredDownloadList} from '30-organisms/filtering/filtered-download-list';
import {init as initOrganismFilterboxLocations} from '30-organisms/filtering/filterbox-locations';
import {init as initOrganismFilteredLocationList} from '30-organisms/filtering/filtered-location-list';



function initOrganisms(app){
	initOrganismHeader(app);
	initOrganismFooter(app);
	initOrganismStickyPageUp(app);
	initOrganismPrivacyLayer(app);
	initOrganismMessageOverlay(app);

	initAtomSelect(app);
	initAtomCheckbox(app);
	initAtomRadiobutton(app);
	initAtomTextinput(app);
	initAtomTextarea(app);

	initInPageNavigation(app);
	initMolecule3dViewer(app);
	initMoleculeVideo(app);
	initMoleculeGoogleMap(app);
	initMoleculeHeaderImage(app);

	initOrganismHeaderImageHomepage(app);
	initOrganismTeaser3Columns(app);
	initTabContentsliderImageTextLink(app);
	initProductTeaserList(app);
	initTeaserSlider4Columns(app);
	initKeyFigures(app);
	initImageFullwidthTextbox(app);
	initVerticalTabsTextImage(app);
	initCollapsible(app);
	initOrganismBreakoutImageTabTeaser(app);
	initOrganismProductIntro(app);
	initContactPanel(app);
	initOrganismFilterbox3Columns(app);
	initOrganismFilteredDownloadList(app);
	initOrganismFilterboxLocations(app);
	initOrganismFilteredLocationList(app);
}



//###[ CONSTANTS ]######################################################################################################

const TARGET_FPS = 30,
	FUZZY_TARGET_FPS = 4;



//###[ SHIV ]##########################################################################################################

let requestAnimationFrame =
	window.requestAnimationFrame
	|| window.mozRequestAnimationFrame
	|| window.webkitRequestAnimationFrame
	|| window.msRequestAnimationFrame
;

let cancelAnimationFrame =
	window.cancelAnimationFrame
	|| window.mozCancelAnimationFrame
;



//###[ APP ]########################################################################################################

export class App {

	constructor(){
		Context.detectPatternlab();

		this._$html = $('html').first();
		this._$body = this._$html.find('body').first();

		this._$html.addClass('ready');
		$(window).one('load', () => {
			this._$html.addClass('loaded');
		});

		if( Context.get('isTouchDevice') ){
			this._$html.addClass('touch');
		}

		if( Context.get('runningInIframe') ){
			this._$html.addClass('is-in-iframe');
		}

		if( Context.get('runningInPatternLab') ){
			this._$html.addClass('is-pattern');

			if( window.parent ){
				let sgHeader = window.parent.document.getElementsByClassName('sg-header');

				if( sgHeader.length > 0 ){
					sgHeader[0].style.background = 'rgba(0, 0, 0, 0.75)';
				}
			}
		}

		if( Context.get('runningInPatternLabList') ){
			this._$html.addClass('is-pattern-list');
		}

		if( Context.get('runningInPatternLabDetails') ){
			this._$html.addClass('is-pattern-details');
		}

		if( Context.get('runningInPatternLabTemplateOrPage') ){
			this._$html.addClass('is-pattern-template-or-page');
		}

		// Deactivate console logging in production
		if( !Context.get('debug') ){
			$.log().disable();
		}

		$.log('###( Witzenmann app started )###');
		$.log('###> Context:', Context.get());

		this._updateLoop = null;
		this._updateLoopCallbacks = {};
		this._fuzzyUpdateLoopCallbacks = {};
		this._resizeCallbacks = {};
		this._scrollCallbacks = {};
		this._waitForWebFontsCallbacks = {};
		this._webFontsLoaded = false;
		this._dynamicDependencies = {};
		this._viewportInfo = {
			scrollTop : $(window).scrollTop(),
			scrollDirection : 'down',
			viewportWidth : window.innerWidth || $(window).width(),
			viewportHeight : window.innerHeight || $(window).height()
		};
		this._viewportInfo.breakpoint = this.getCurrentBreakpoint();

		initOrganisms(this);

		this._prepareClickedStates();
		this._setupGlobalEvents();
		this.startUpdateLoop();
	}



	_prepareClickedStates(){
		$('body').on('click', 'a, button, .button, input[type=button], input[type=submit]', function(){
			$(this).addClass('clicked');
			$.schedule(200, () =>{
				$(this)
					.removeClass('clicked')
					.blur()
				;
			});
		});
	}



	_setupGlobalEvents(){
		$(window).on('scroll.app', _.throttle(() => {
			_.each(this._scrollCallbacks, function(callback){
				callback();
			});
		}, 100));

		$(window).on('resize.app', _.throttle(() => {
			_.each(this._resizeCallbacks, function(callback){
				callback();
			});

			$(window).triggerHandler('scroll.app');
		}, 100));

		$.waitForWebfonts(['SpaceMono-BoldItalic', 'SpaceMono-Bold', 'SpaceMono-Italic', 'SpaceMono-Regular', 'Poppins-Regular', 'Poppins-Italic', 'Poppins-Medium', 'Poppins-MediumItalic', 'Poppins-Semibold', 'Poppins-SemiboldItalic', 'Poppins-Bold', 'Poppins-BoldItalic', 'Syne-Regular', 'Syne-Medium', 'Syne-Semibold', 'Syne-Bold', 'Source-Han-Sans-CN-Regular', 'Source-Han-Sans-CN-Medium', 'Source-Han-Sans-CN-Bold', 'Source-Han-Sans-JP-Regular', 'Source-Han-Sans-JP-Medium', 'Source-Han-Sans-JP-Bold', 'Source-Han-Sans-KR-Regular', 'Source-Han-Sans-KR-Medium', 'Source-Han-Sans-KR-Bold'], () => {
			this._webFontsLoaded = true;

			_.each(this._waitForWebFontsCallbacks, function (callback) {
				callback();
			});
		}, 'helvetica, sans-serif');
	}



	startUpdateLoop(){
		let _this_ = this;

		let throttledUpdate = _.throttle(function(){
			_this_._updateViewportInfo();

			_.each(_this_._updateLoopCallbacks, (callback) => {
				callback(_this_._viewportInfo);
			});
		}, Math.round(1000 / TARGET_FPS));

		let throttledFuzzyUpdate = _.throttle(function(){
			_.each(_this_._fuzzyUpdateLoopCallbacks, (callback) => {
				callback(_this_._viewportInfo);
			});
		}, Math.round(1000 / FUZZY_TARGET_FPS));

		function step(){
			throttledUpdate();
			throttledFuzzyUpdate();
			_this_._updateLoop = requestAnimationFrame(step);
		}

		this._updateLoop = requestAnimationFrame(step);
	}



	stopUpdateLoop(){
		if( $.isSet(this._updateLoop) ){
			cancelAnimationFrame(this._updateLoop);
			this._updateLoop = null;
		}
	}



	registerUpdateLoopCallback(name, callback){
		$.assert($.isSet(name), 'app.registerUpdateLoopCallback | name is not defined');
		$.assert($.isFunction(callback), 'app.registerUpdateLoopCallback | callback is not a function');

		name = ''+name;

		this._updateLoopCallbacks[name] = callback;

		return name;
	}



	unregisterUpdateLoopCallback(name){
		$.assert($.isSet(name), 'app.registerUpdateLoopCallback | name is not defined');

		name = ''+name;

		if( $.isSet(this._updateLoopCallbacks[name]) ){
			delete this._updateLoopCallbacks[name];
		}

		return name;
	}



	registerFuzzyUpdateLoopCallback(name, callback){
		$.assert($.isSet(name), 'app.registerFuzzyUpdateLoopCallback | name is not defined');
		$.assert($.isFunction(callback), 'app.registerFuzzyUpdateLoopCallback | callback is not a function');

		name = ''+name;

		this._fuzzyUpdateLoopCallbacks[name] = callback;

		return name;
	}



	unregisterFuzzyUpdateLoopCallback(name){
		$.assert($.isSet(name), 'app.unregisterFuzzyUpdateLoopCallback | name is not defined');

		name = ''+name;

		if( $.isSet(this._fuzzyUpdateLoopCallbacks[name]) ){
			delete this._fuzzyUpdateLoopCallbacks[name];
		}

		return name;
	}



	registerResizeCallback(name, callback){
		$.assert($.isSet(name), 'app.registerResizeCallback | name is not defined');
		$.assert($.isFunction(callback), 'app.registerResizeCallback | callback is not a function');

		this._resizeCallbacks[''+name] = callback;
	}



	unregisterResizeCallback(name){
		$.assert($.isSet(name), 'app.unregisterResizeCallback | name is not defined');

		if( $.isSet(this._resizeCallbacks[''+name]) ){
			delete this._resizeCallbacks[''+name];
		}
	}



	registerScrollCallback(name, callback){
		$.assert($.isSet(name), 'app.registerScrollCallback | name is not defined');
		$.assert($.isFunction(callback), 'app.registerScrollCallback | callback is not a function');

		this._scrollCallbacks[''+name] = callback;
	}



	unregisterScrollCallback(name){
		$.assert($.isSet(name), 'app.unregisterScrollCallback | name is not defined');

		if( $.isSet(this._scrollCallbacks[''+name]) ){
			delete this._scrollCallbacks[''+name];
		}
	}



	registerWaitForWebFontsCallback(name, callback){
		$.assert($.isSet(name), 'app.registerWaitForWebFontsCallback | name is not defined');
		$.assert($.isFunction(callback), 'app.registerWaitForWebFontsCallback | callback is not a function');

		if (!this._webFontsLoaded) {
			this._waitForWebFontsCallbacks[''+name] = callback;
		} else {
			_.defer(() => {
				callback();
			});
		}
	}



	unregisterWaitForWebFontsCallback(name){
		$.assert($.isSet(name), 'app.unregisterWaitForWebFontsCallback | name is not defined');

		if( $.isSet(this._waitForWebFontsCallbacks[''+name]) ){
			delete this._waitForWebFontsCallbacks[''+name];
		}
	}



	loadDynamicDependency(name, url, expectedVal, async=true, defer=true) {
		$.assert($.isSet(name), 'app.registerDynamicDependency | name is no defined');
		$.assert($.isSet(url), 'app.registerDynamicDependency | url is no defined');

		if (this._dynamicDependencies[''+name]) {
			return this._dynamicDependencies[''+name];
		} else {
			let pollEndTime = Number(new Date()) + 5000,
				pollInterval = 1000,
				deferred = $.Deferred(),
				$script = document.createElement('script');
				$script.async = async;
				$script.defer = defer;

				$script.onerror = function () {
					deferred.reject('script could not be loaded');
				};

				this._dynamicDependencies[''+name] = deferred;

			if (!$.isSet(expectedVal)) {
				$script.onload = function () {
					deferred.resolve();
				};
			} else {
				$script.onload =  function () {
					let checkForExpectedValue = () => {
						if (_.has(window, expectedVal) ) {
							deferred.resolve();
						} else if(Number(new Date()) < pollEndTime) {
							setTimeout(() => {
								requestAnimationFrame(checkForExpectedValue);
							}, pollInterval);
						} else {
							throw new Error('expectedVal: ' + expectedVal + 'not found');
						}
					};

					requestAnimationFrame(checkForExpectedValue);
				};
			}

			document.body.appendChild($script);
			$script.src = url;

			return deferred;
		}
	}



	_updateViewportInfo(){
		let currentVpWidth = window.innerWidth || $(window).width(),
			currentBreakpoint = this.getBreakpointBySize(currentVpWidth),
			oldBreakpoint = this.getBreakpointBySize(this._viewportInfo.viewportWidth);

		this._viewportInfo.viewportWidth = currentVpWidth;
		this._viewportInfo.viewportHeight = window.innerHeight || $(window).height();

		let newScrollTop = $(window).scrollTop();
		if( newScrollTop > this._viewportInfo.scrollTop + 10 ){
			this._viewportInfo.scrollDirection = 'down';
		} else if( newScrollTop < this._viewportInfo.scrollTop - 10 ){
			this._viewportInfo.scrollDirection = 'up';
		}
		this._viewportInfo.scrollTop = newScrollTop;

		if( currentBreakpoint !== oldBreakpoint ){
			$(window).triggerHandler('breakpointchange.app', [oldBreakpoint, currentBreakpoint]);
		}
		this._viewportInfo.breakpoint = currentBreakpoint;
	}



	getBreakpointBySize(size){
		if(size < BREAKPOINT_TABLET) {
			return 'small';
		}

		if(size < BREAKPOINT_DESKTOP) {
			return 'medium';
		}

		return 'large';
	}



	getCurrentBreakpoint(){
		return this.getBreakpointBySize(this._viewportInfo.viewportWidth);
	}



	getViewportInfo(){
		return this._viewportInfo;
	}
}



// init whole app only when document is ready, this call method prevents the need for any other document ready
// handlers and constitutes only a very minimal offset from the call in the body foot
$(() => {
	let app = new App();
});
